import { canUseDOM } from "history/DOMUtils";
import { HistoryType, pushQueryParams } from "../../../../common-deprecated/History";
import Navigation, { type NavigationType } from "../../shared-logic/utils/Navigation";
import { queryStringToObject } from "../../../../common-deprecated/utils";
import type { QueryType } from "../../../../common-deprecated/server/types";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";
import { getModelMapValueById } from "../../../../common-deprecated/settings/utils/commonSettingUtils";

export const setEquipmentFilterQuery = (navigation: NavigationType, id: string, isSelected: boolean): void => {
    const { path } = navigation;

    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    pushQueryParams({ path, filterEquipment: `${isSelected}:${id}` }, HistoryType.Build);
};

export const getEquipmentFilterQuery = (query?: QueryType): { equipmentId: string; isSelected: boolean } => {
    let queryString;

    if (query || !canUseDOM) {
        queryString = query;
    } else {
        queryString = queryStringToObject(window.location.search);
    }

    if (!queryString?.filterEquipment) return { equipmentId: "", isSelected: false };

    const queryValues = (queryString.filterEquipment as string).split(":");

    return {
        equipmentId: queryValues[1],
        isSelected: queryValues[0] === "true",
    };
};

export const parseUrl = (url: string): NavigationType | false => {
    try {
        const queryString = url.split("?")[1];
        const params = Object.fromEntries(new URLSearchParams(queryString));
        return Navigation.parsePath(params);
    } catch (e) {
        return false;
    }
};

export const isBuildUrl = (url: string, commonSettings: CommonSettingsType, modelId: string): boolean => {
    const modelMatch = getModelMapValueById(commonSettings, modelId);
    const parsedUrl = parseUrl(url);
    const buildPageUrl = modelMatch?.links?.buildPage?.split("/").slice(-2).join("/") || false;
    const hasBuildPageUrl = buildPageUrl && url.includes(buildPageUrl);
    const hasStep = parsedUrl && !!parsedUrl.step;
    return hasBuildPageUrl || hasStep;
};
